import { http } from "./config.api.js"

// 特殊
export const post = (controllName, method, params) => {
    return http.post("/" + controllName + "/" + method, params).then(res => res.data)
}

// 通过后台上传base64文件
export const uploadByJava = (params) => {
    let url = "http://47.96.9.68:8080/secsealUpload";
    if (process.env.NODE_ENV === 'production') {
        url = "http://47.96.136.131/secsealUpload";
    }
    return http.post(url, params).then(res => res.data)
}

// 页面跳转获取MD5
export const getMD5 = (params) => { return http.get("/encrypt/encryptByMD5/" + params).then(res => res.data) }

// 目录
export const getTreeData = (params) => { return http.get("/user/functions/" + params).then(res => res.data) }

// 附件列表
export const getAttach = (params) => { return http.get("/tempAttach/findHyTempAttachsByCodeAndPositionID", { urlParams: params }).then(res => res.data) }

// 附件上传
// {data:{tblId:"",tblName:"",attPath:"",displayName:"",typeId:"",attName:"",code:"",}}
export const uploadAttach = (params) => { return http.post("/attachDetail/afterUploadSuccess", params).then(res => res.data) }

//根据tblid获取附件
export const findAttachDetailByRecordId = (params) => { return http.get("/attachDetail/findAttachDetailByRecordId", { urlParams: params }).then(res => res.data) }
// 附件删除
// {data:"recordId"}
export const deleteAttach = (params) => { return http.delete("/attachDetail/delete", { urlParams: params }).then(res => res.data) }

// 项目详情的附件
export const getProAttach = (params) => { return http.get("/tempAttach/findHyTempAttachsDeclareByCodeAndPositionID", { urlParams: params }).then(res => res.data) }

// 跳转至电子档案公示平台
export const jump2Seer = (params) => { return http.get("/user/jump2Seer", { urlParams: params }).then(res => res.data) }

//文书查看-集合
export const getWrit = (subUrl, params) => { return http.get(subUrl + "/", { urlParams: params }).then(res => res.data) }

// 获取字典
export const getDic = (params) => {
    if (params.limit.dictId == null || params.limit.dictId == "") {
        return new Promise((resolve, reject) => {}).then(() => "")
    }
    return http.get("/sysType/getTypeName/", { urlParams: params }).then(res => {
        //资质等级为中文则返回原数据
        let regexp = /^[\u4e00-\u9fa5]+$/;
        if(params.limit.dictTypeId == "domus_bulQualLevel" && regexp.test(params.limit.dictId)){
            return params.limit.dictId;
        }else{
            return res.data;
        }
    })
}

// 获取资质等级的字典
export const getQualityDic = (params) => {
    return http.get("/sysType/getUnitQualityAndLevel/", { urlParams: params }).then(res => res.data)
}

// {"userId":"xxx","time":"xxx","str":"xxx"}
export const supervisionUnitLogin = (params) => {
    return http.post("/user/verifyLoginFromRemaius", params).then(res => res.data)
}

// UnitPerson	建设单位负责人
// SE	总监理工程师
// pm	项目经理
// admin	系统管理员

// BuildUnit	施工单位
// SupervisionUnit	监理单位
// unit	建设单位
//登录和权限
export const getToken = (params) => { return http.get("/user/getToken", { urlParams: params }).then(res => res.data) }

export const Auth = {
    login: params => {
        let msg = { userId: "", roleId: "" };
        // params { userId: this.userId.trim(), password: this.password }
        return http.post('/user/login', params).then(result => {
            if (result == null || result == "") {
                return { status: false, msg: "登录失败，可能是用户名或密码错误，请重试" };
            }
            let res = result.data;
            if (res.code == "0") {
                let mulRole = res.data.roles.indexOf(",") == -1 ? false : true;
                localStorage.setItem("userinfo", JSON.stringify({
                    userId: res.data.userId,
                    roleId: res.data.roles,
                    roleName: res.data.operatorname,
                    "empid": res.data.empid,
                    "unitId": res.data.unitId,
                    "operatorid": res.data.operatorid,
                    mulRole: mulRole, //切换角色使用
                    roleIds: res.data.roles, //切换角色使用
                    orgArea: res.data.orgArea == null ? "" : res.data.orgArea //企业基本信息新增的时候要用到
                }));

                localStorage.setItem("token", res.token);
                return { status: true, msg: "", mulRole: mulRole };
            } else if (res.code == "-2") {
                return { status: false, msg: "密码错误，请重试" };
            } else if (res.code == "-1") {
                return { status: false, msg: "账号不存在" };
            } else if (res.code == "-3") {
                return { status: false, msg: "请使用企业或人员帐号登录。" };
            } else if (res.code == "-4") {
                return { status: false, msg: "解密失败，不支持encode方式" };
            }
        }).catch(res => {
            // console.log(res)
            return { status: false, msg: "登录失败，可能是用户名或密码错误，请重试" };
        })
    },
    changeUserRole: () => { return http.get('/user/changeUserRole', { urlParams: {} }).then(res => res.data) },
    isLogin: () => {
        return localStorage.userinfo ? true : false;
    },
    postLogout: () => {
        return http.post("/user/logout").then(res => {
            localStorage.clear();
            localStorage.setItem('token', "initlogout");
            return res.data;
        })
    },
    logout: (to, from, next) => {
        localStorage.clear();
        localStorage.setItem('token', "initlogout");
        next('/login');
        // http.post("/user/logout").then((res) => {
        //     localStorage.clear();
        //     localStorage.setItem('token', "initlogout");
        //     next('/login');
        // });
    },
    // 互联互通的接口
    loginLinktom: params => {
        let msg = { userId: "", roleId: "" };
        return http.get('/user/validation', { urlParams: params, isLogin: true }).then(res => {
            if (!res || res == "") {
                return { status: false, msg: "服务器繁忙，请稍候" };
            }
            if (res.data.data.data.length > 0) { //登录失败返回{data:{ data : [] }}
                let json = res.data.data.data[0]
                localStorage.setItem("userinfo", JSON.stringify({ userId: json.C_USER_ID, roleId: json.ROLEID, }));
                localStorage.setItem("token", res.data.token);
                return { status: true, msg: "" };
            } else {
                return { status: false, msg: "帐号或密码错误，请重试" };
            }
        }).catch(res => {
            // console.log(res)
            return { status: false, msg: "服务器繁忙，请稍候" };
        })
    },
}



// WEBPACK FOOTER //
// ./src/api/api_common.js